import { forwardRef } from 'react'

export interface FormAlertProps {
  readonly title: string
  readonly detail?: string
}

/**
 * Page-level error banner for a server-rejected submission (invalid
 * credentials, account locked, password policy, etc.) — as opposed to
 * `<FormField>`'s per-field validation errors. `role="alert"` makes
 * assistive tech announce it immediately on mount without a separate
 * `aria-live` wrapper (an alert role carries an implicit assertive live
 * region). The caller moves focus to this element (via the forwarded ref)
 * whenever a new error appears, per the accessibility-wcag skill's focus
 * management requirement for form submission errors.
 */
export const FormAlert = forwardRef<HTMLDivElement, FormAlertProps>(function FormAlert(
  { title, detail },
  ref,
) {
  return (
    <div ref={ref} role="alert" tabIndex={-1} className="form-alert">
      <p className="form-alert-title">{title}</p>
      {detail && <p className="form-alert-detail">{detail}</p>}
    </div>
  )
})
